import io from '../socket-client';
import { selectVideoTool, selectUser } from './tools';

export const SELECT_DAY = 'SELECT_DAY';
export const SELECT_TOOL = 'SELECT_TOOL';
export const LOAD_TRACK = 'LOAD_TRACK';
export const TRACK_UPDATES_RECEIVING = 'TRACK_UPDATES_RECEIVING';
export const TRACK_UPDATES_RECEIVED = 'TRACK_UPDATES_RECEIVED';
export const LOAD_USERGROUPS = 'LOAD_USERGROUPS';
export const SET_SELECTION_MODE = 'SET_SELECTION_MODE';

export function selectDay(date) {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return (dispatch, getState) => {
    dispatch(selectUser());
    dispatch(selectVideoTool(false));
    dispatch({ type: SELECT_DAY, date });
    updateTracks(dispatch, getState);
  };
}

export function loadTracks(date, done) {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      if (!state.map.usergroups) {
        fetchUsergroups(getState, date, dispatch);
      }
      const day = state.map.days[date];
      const receivingStatus = day ? day.receivingStatus : undefined;
      if (receivingStatus !== TRACK_UPDATES_RECEIVING) {
        fetchTracksUpdates(getState, date, dispatch, done);
      }
    } catch (error) {
      console.error(error);
    }
  };
}

export function selectTool(tool) {
  return { type: SELECT_TOOL, tool };
}

export function setSelectionMode(mode) {
  return { type: SET_SELECTION_MODE, mode };
}

const getStartOfNow = () => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return now.getTime();
};

const isOnline = selectedDay => selectedDay &&
  selectedDay.date.getTime() === getStartOfNow();

let updateTimer;

function updateTracks(dispatch, getState) {
  const selectedDay = getState().map.selectedDay;
  if (selectedDay) {
    dispatch(loadTracks(selectedDay.date));
  }
  if (!updateTimer) {
    let lastUpdateTime = 0;
    updateTimer = setInterval(() => {
      const updateInterval = isOnline(getState().map.selectedDay) ? 5000 : 15000;
      if (Date.now() - lastUpdateTime > updateInterval) {
        lastUpdateTime = Date.now();
        updateTracks(dispatch, getState);
      }
    }, 500);
  }
}

function getTrackRequests(tracks) {
  const requests = {};
  for (const trackId of Object.keys(tracks)) {
    const track = tracks[trackId];
    const objects = {};
    requests[trackId] = {
      coords: 1000000000,
      medias: track.medias.length,
      infos: track.infos.length,
      reports: track.infos.length,
      objects,
    };
    for (const objectId of Object.keys(track.objects)) {
      const object = track.objects[objectId];
      objects[objectId] = {
        data: object.data.length,
        revision: object.revision,
      };
    }
  }
  return requests;
}

function fetchTracksUpdates(getState, date, dispatch, done) {
  const selectedDay = getState().map.days[date];
  const selectedUser = getState().map.selectedUser;
  const strict = getState().map.selectionMode === 'single';
  let tracks = {};
  if (strict) {
    if (selectedDay && selectedUser) {
      const selectedTrack = selectedDay.tracks[selectedUser.id];
      if (selectedTrack) {
        tracks = getTrackRequests({ [selectedUser.id]: selectedTrack });
      } else {
        tracks[selectedUser.id] = {
          coords: 0,
          medias: 0,
          infos: 0,
          reports: 0,
          objects: {},
        };
      }
    }
  } else {
    tracks = getTrackRequests(selectedDay.tracks);
  }
  dispatch({ type: TRACK_UPDATES_RECEIVING, day: date });
  fetchActions('usertracks', { day: date, tracks, strict, nocoords: true }, dispatch, () => {
    dispatch({ type: TRACK_UPDATES_RECEIVED, day: date });
    if (done) {
      done();
    }
  });
}

function fetchUsergroups(getState, date, dispatch) {
  fetchActions('usergroups', {}, dispatch);
}

export function fetchActions(path, req, dispatch, done) {
  const fetchAction = (type, payload) => dispatch({ type, req, payload });
  io.fetch(path, req, fetchAction, res => {
    if (res && res.error) {
      if (res.error === 'unauthorized') {
        window.localStorage.removeItem('access_token');
        window.location.reload(true);
      }
      console.log(res.error);
    } else if (done) {
      done(res);
    }
  });
}


export function logout() {
  const { protocol, host } = window.location;
  window.location.replace(`${protocol}//${host}`);
}



// WEBPACK FOOTER //
// ./src/actions/map.js